import React from 'react'

const LogoBar: React.FC = () => {
  return (
    <div style={{ display: 'flex', marginBottom: '0.5rem' }}>
      <div
        style={{
          width: '111px',
          height: '38px',
          marginRight: '5px',

          backgroundImage: 'url(images/freedom.svg)',
          backgroundPosition: '50%',
          backgroundRepeat: 'no-repeat',
        }}
      ></div>
      <div
        style={{
          backgroundImage: 'url(images/swift.svg)',
          padding: '1.22rem',
          backgroundPosition: '50%',
          backgroundRepeat: 'no-repeat',
          backgroundSize: '2rem',
        }}
      ></div>
    </div>
  )
}
export default LogoBar
